import React from "react";
import Sprite from "./img/sprite.svg";

function icon(name) {
    return `${Sprite}#${name}`;
}

export default function SocialBase({ news, className }) {
    const vk = `http://vk.com/share.php?url=${news.absolute_url}&title=${news.title}&image=${news.image_absolute_url}`;

    const ok = `http://www.odnoklassniki.ru/dk?st.cmd=addShare&st.s=1&st.comments=${news.title}&st._surl=${
        news.absolute_url
    }`;

    const tw = `http://twitter.com/share?text=${news.title}&url=${news.absolute_url}&counturl=${
        news.image_absolute_url
    }`;

    const fb = `http://www.facebook.com/share.php?u=${news.absolute_url}&title=${news.title}&image=${
        news.image_absolute_url
    }`;

    const clsName = "share " + (className || "");

    return (
        <div className={clsName}>
            <div className="share__text">Поделиться</div>
            <div className="share__list">
                <li>
                    <a target="_blank" href={vk}>
                        <svg className="icon icon-vk ">
                            <use xlinkHref={icon("icon-vk")} />
                        </svg>
                    </a>
                </li>
                <li>
                    <a target="_blank" href={tw}>
                        <svg className="icon icon-tw ">
                            <use xlinkHref={icon("icon-tw")} />
                        </svg>
                    </a>
                </li>
                <li>
                    <a target="_blank" href={ok}>
                        <svg className="icon icon-ok ">
                            <use xlinkHref={icon("icon-ok")} />
                        </svg>
                    </a>
                </li>
                <li>
                    <a target="_blank" href={fb}>
                        <svg className="icon icon-facebook ">
                            <use xlinkHref={icon("icon-facebook")} />
                        </svg>
                    </a>
                </li>
            </div>
        </div>
    );
}
